import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { rollbarFactory } from './shared/services/error-handler.service';
var ɵ0 = function (http) { return new TranslateHttpLoader(http, './assets/i18n/', '.json'); }, ɵ1 = rollbarFactory;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1 };
